import firebase from "./firebase";
import request from "../infra/request";

export const updateRelationshipOfCaseManagerAndStaff = async ({ practitionerId, staff }) => {
  try {
    await request.put(`/admin/practitioners/${encodeURIComponent(practitionerId)}/staff`, { staff });
    return { result: "", error: false };
  } catch (err) {
    console.log(err);
    return { result: "", error: true };
  }
};

export const fetchPractitionerToStaff = async (callback) => {
  try {
    firebase
      .database()
      .ref("/practitioner_to_staff")
      .on("value", (snapshot) => {
        const data = snapshot.val();
        callback(data);
      });
    return { result: "", error: false };
  } catch (err) {
    console.log(err);
    return { result: "", error: true };
  }
};
